<div class="areas-container">
  <div class="areas-header">
    <div>
      <div class="areas-title">
        @if (!currentProject?.created_at) {
        <div
          class="project-menu"
          [matMenuTriggerFor]="projectMenu"
          #t="matMenuTrigger"
          (click)="$event.stopPropagation()"
        >
          <inline-svg
            [src]="getRootStateIcon(currentProject)"
            className="title-icon"
            hoverColor="#5796D7"
            parentClass="project-menu"
            color="rgba(133, 187, 243, 1)"
          ></inline-svg>
          <inline-svg
            src="Input_arrow.svg"
            className="arrow-icon"
            [color]="t.menuOpen ? 'rgba(133, 187, 243, 1)' : '#A5B5BDFF'"
            hoverColor="#7F8F98"
            parentClass="project-menu"
            [ngClass]="{ open: t.menuOpen === true }"
          ></inline-svg>
        </div>
        }
        <mat-menu #projectMenu="matMenu">
          <button
            mat-menu-item
            class="menu-slot"
            (click)="updateRootState('root')"
            [ngClass]="{ active: rootState === 'root' }"
          >
            <inline-svg
              src="project.svg"
              [color]="
                rootState === 'root' ? 'rgba(133, 187, 243, 1)' : '#A5B5BDFF'
              "
              className="title-icon"
            ></inline-svg>
            <span>My Projects</span>
          </button>
          <button
            mat-menu-item
            class="menu-slot"
            [ngClass]="{ active: rootState === 'shared' }"
            (click)="updateRootState('shared')"
          >
            <inline-svg
              src="Shared.svg"
              [color]="
                rootState === 'shared' ? 'rgba(133, 187, 243, 1)' : '#A5B5BDFF'
              "
              className="title-icon"
            ></inline-svg>
            <span>Shared with me</span>
          </button>
          <button
            mat-menu-item
            class="menu-slot"
            [ngClass]="{ active: rootState === 'archived' }"
            (click)="updateRootState('archived')"
          >
            <inline-svg
              src="archive.svg"
              [color]="
                rootState === 'archived'
                  ? 'rgba(133, 187, 243, 1)'
                  : '#A5B5BDFF'
              "
              className="title-icon"
            ></inline-svg>
            <span>My Archives</span>
          </button>
        </mat-menu>
        @if (currentProject?.created_at) {
        <inline-svg
          [src]="getRootStateIcon(currentProject)"
          className="title-icon"
          color="rgba(133, 187, 243, 1)"
          (click)="goToRoot()"
        ></inline-svg>
        <inline-svg
          src="page_back.svg"
          className="title-icon"
          color="#272727FF"
          hoverColor="#A5B5BD"
          (click)="goProjectUp($event)"
        ></inline-svg>
        }
        <span>{{
          !currentProject?.created_at
            ? getRootStateTitle()
            : currentProject?.name
        }}</span>
      </div>
      <div class="header-actions">
        @if (!this.currentProject ? this.rootState === 'root' :
        (this.currentProject?.is_owned_by_current_user ||
        this.currentProject?.effective_permissions.can_update)){
        <inline-svg
          [src]="!currentProject?.created_at ? 'Plus.svg' : 'add-folder.svg'"
          (click)="createProject()"
          [matTooltip]="
            !currentProject?.created_at ? 'Create Project' : 'Create Folder'
          "
        ></inline-svg>
        }

        <mat-menu
          #filter="matMenu"
          yPosition="above"
          xPosition="after"
          class="uploadBox"
          hasBackdrop="false"
        >
          <frmg-filter
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
            (closeMenu)="closeFilter()"
            (onApply)="onApplyFilter($event)"
            [projectId]="currentProject?.project_id || currentProject?.id"
            [folderId]="currentProject?.id"
            [filter]="areaService.filterBody"
          />
        </mat-menu>
        @if (currentProject && currentProject.path !== 'root' && showUploadIcon)
        {
        <inline-svg
          src="upload_file.svg"
          (click)="showUploadFile()"
        ></inline-svg>
        } @if (currentProject && currentProject.path !== 'root' &&
        !showUploadIcon) {
        <div class="filter-icon" [ngClass]="{ active: menuTrigger.menuOpen }">
          <inline-svg
            src="upload_file.svg"
            [ngClass]="{ active: menuTrigger.menuOpen }"
            [activeColor]="'#85bbf3'"
            [matMenuTriggerFor]="importModal"
            #menuTrigger="matMenuTrigger"
            matTooltip="Upload Files"
          ></inline-svg>
          @if (isFilesHasIssues()) {
          <div
            class="upload-filled-dot"
            [class.error]="isFilesWithErrors()"
            [class.warning]="isFilesWithWarnings()"
          ></div>
          }
        </div>
        <mat-menu
          #importModal="matMenu"
          yPosition="above"
          xPosition="after"
          class="uploadBox"
          hasBackdrop="false"
        >
          <div matMenuContent (click)="$event.stopPropagation()">
            <frmg-file-processing-status
              [projectId]="currentProject.id"
              [rootProjectId]="rootProjectId"
              [uploads]="uploads"
              (importMore)="showUploadFile()"
              (onClose)="menuTrigger.closeMenu()"
              (goToFolder)="openProject($event, null)"
            />
          </div>
        </mat-menu>
        } @if (!showSearch) {
        <inline-svg
          src="search.svg"
          (click)="toggleSearch()"
          matTooltip="Search area"
        ></inline-svg>
        } @if (showSearch) {
        <inline-svg
          src="search_close.svg"
          (click)="toggleSearch()"
          matTooltip="Close search"
          color="#5E84F7"
        ></inline-svg>
        }
      </div>
    </div>
    @if (showSearch) {
    <div
      class="search-field"
      [ngClass]="{ selected: this.searchAreaCtrl.value?.length }"
    >
      <mat-form-field appearance="outline">
        <inline-svg src="search.svg" matPrefix></inline-svg>
        <mat-label>Area name</mat-label>
        <div class="search-input">
          <input
            matInput
            #searchInput
            [formControl]="searchAreaCtrl"
            placeholder="Search..."
            (focus)="showResults(true)"
            (blur)="showResults(false)"
          />
        </div>
        @if (searchAreaCtrl.value.length) {
        <div matSuffix class="search-suffix" (click)="$event.stopPropagation()">
          <inline-svg
            src="small_close.svg"
            (click)="clearSearch()"
          ></inline-svg>
        </div>
        }
      </mat-form-field>
      <div class="separator"></div>
      <mat-form-field appearance="outline" class="search-select">
        <mat-select
          [(ngModel)]="searchType"
          (selectionChange)="startSearch(searchAreaCtrl.value)"
          panelClass="search-panel"
        >
          <mat-option value="all">All folders</mat-option>
          @if (currentProject) {
          <mat-option [value]="currentProject.id">This folder </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    } @if (showSearch && searchResults.length && showSearchResults &&
    searchFinished) {
    <div class="search-results">
      @if ((getSearchResultsByType('projects').length && searchType == 'all') ||
      getSearchResultsByType('folders').length) {
      <mat-accordion>
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span>FOLDERS</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for (item of getSearchResultsByType('projects'); track item) {
          <div class="search-item" (click)="goToItem(item)">
            <ng-template
              [ngTemplateOutlet]="searchResult"
              [ngTemplateOutletContext]="{
                item: item
              }"
            ></ng-template>
          </div>
          } @for (item of getSearchResultsByType('folders'); track item) {
          <div class="search-item" (click)="goToItem(item)">
            <ng-template
              [ngTemplateOutlet]="searchResult"
              [ngTemplateOutletContext]="{
                item: item
              }"
            ></ng-template>
          </div>
          }
        </mat-expansion-panel>
      </mat-accordion>
      } @if (getSearchResultsByType('aois').length) {
      <mat-accordion>
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span>AOIs</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for (item of getSearchResultsByType('aois'); track item) {
          <div class="search-item" (click)="goToItem(item)">
            <ng-template
              [ngTemplateOutlet]="searchResult"
              [ngTemplateOutletContext]="{
                item: item
              }"
            ></ng-template>
          </div>
          }
        </mat-expansion-panel>
      </mat-accordion>
      }
    </div>
    } @if (showSearch && !searchResults.length && showSearchResults &&
    searchFinished) {
    <div class="search-results no-results">
      <span class="no-results-title">No areas found.</span>
      <span class="no-results-subtitle"
        >Please try adjusting search or filter to find what you’re looking
        for.</span
      >
    </div>
    }
  </div>
  <div class="areas-list">
    <div class="list-selector">
      @if (currentProject?.path) {
      <mat-checkbox
        [disabled]="!list?.length"
        [indeterminate]="someChecked()"
        [checked]="selectAll"
        (change)="setAll($event.checked)"
        matTooltip="Select/deselect all"
      >
      </mat-checkbox>
      }
      <span>
        <strong>{{
          getCheckedAmount() ||
            (currentProject?.path ? areaService.count : projects?.length)
        }}</strong>
        {{ getCheckedAmount() ? " selected " : "" }}
        {{ !currentProject?.path ? " projects" : " items" }}</span
      >

      <div class="list-element-actions selector-actions">
        @if (!getCheckedAmount()) {
        <inline-svg
          src="sort_by.svg"
          matTooltip="Sort by"
          [color]="!orderTrigger.menuOpen ? '#A5B5BD' : '#5E84F7'"
          hoverColor="#7F8F98"
          [matMenuTriggerFor]="orderMenu"
          [ngClass]="{ active: orderTrigger.menuOpen }"
          #orderTrigger="matMenuTrigger"
        >
        </inline-svg>

        @if(currentProject?.path) {
        <div class="filter-icon">
          <inline-svg
            src="Filter.svg"
            matTooltip="Filters"
            [color]="!filterTrigger.menuOpen ? '#A5B5BD' : '#5E84F7'"
            hoverColor="#7F8F98"
            [matMenuTriggerFor]="filter"
            [ngClass]="{ active: filterTrigger.menuOpen }"
            #filterTrigger="matMenuTrigger"
          >
          </inline-svg>
          @if (getAppliedFiltersLength()) {
          <div class="counter">
            <span>
              {{ getAppliedFiltersLength() }}
            </span>
          </div>
          }
        </div>
        }
        <mat-menu #orderMenu="matMenu">
          <button
            mat-menu-item
            class="menu-slot"
            (click)="updateSortState('created_at:desc')"
            [ngClass]="{ active: sortState === 'created_at:desc' }"
          >
            <span>Newest first</span>
          </button>
          <button
            mat-menu-item
            class="menu-slot"
            (click)="updateSortState('created_at:asc')"
            [ngClass]="{ active: sortState === 'created_at:asc' }"
          >
            <span>Oldest first</span>
          </button>
          <button
            mat-menu-item
            class="menu-slot"
            (click)="updateSortState('name:asc')"
            [ngClass]="{ active: sortState === 'name:asc' }"
          >
            <span>A-Z</span>
          </button>
          <button
            mat-menu-item
            class="menu-slot"
            (click)="updateSortState('name:desc')"
            [ngClass]="{ active: sortState === 'name:desc' }"
          >
            <span>Z-A</span>
          </button>
        </mat-menu>
        } @if (getCheckedAmount()) {
        <button mat-button class="frmg-secondary-button">
          <inline-svg
            src="download.svg"
            (click)="downloadSelected()"
            color="#A5B5BD"
            hoverColor="#7F8F98"
            matTooltip="Request download"
          >
          </inline-svg>
        </button>
        <button mat-button class="frmg-primary-button">
          <inline-svg
            src="Reports.svg"
            (click)="generateReport()"
            color="#FFFFF"
            matTooltip="Generate Exposure Report"
          >
          </inline-svg>
        </button>
        <div class="list-element-actions-menu">
          <inline-svg
            src="Hamburger_menu.svg"
            [matMenuTriggerFor]="actionMenu"
            #bulkMenuTrigger="matMenuTrigger"
            [color]="bulkMenuTrigger.menuOpen ? '#5E84F7' : '#A5B5BD'"
            hoverColor="#7F8F98"
            (click)="$event.stopPropagation()"
          ></inline-svg>
          <mat-menu #actionMenu="matMenu">
            <button mat-menu-item (click)="moveAreas()" class="menu-slot">
              Move to
            </button>
            <button mat-menu-item (click)="deleteAreas()" class="menu-slot">
              Delete Areas
            </button>
          </mat-menu>
        </div>
        }
      </div>
    </div>
    <div class="horizontal-separator"></div>
    <div
      class="list-container"
      #listContainer
      [ngClass]="{ spinner: loadingData() }"
      scrollNearEnd
      (nearEnd)="loadAreas()"
      (nearTop)="loadAreas(true)"
    >
      @if (!loadingData()) {
      <!--                     [ngClass]="{'project' : project.path.split('/').length === 2}"-->
      @for (project of projects; track project) {
      <div
        class="list-element folder-element project"
        [id]="project.id"
        (click)="openProject(project, $event)"
        [ngClass]="{ archived: project.is_archived }"
      >
        <div class="list-element-container">
          <div class="list-element-info">
            <div class="list-element-title">
              <inline-svg
                [src]="getRootStateIcon(project)"
                className="list-icon"
                color="rgba(133, 187, 243, 1)"
              ></inline-svg>
              <span>
                {{ project.name }}
              </span>
            </div>
            @if (project.description) {
            <div
              class="list-element-tags element-desc"
              [matTooltip]="project.description"
              matTooltipPosition="right"
              [matTooltipDisabled]="project.description?.length < 40"
            >
              <span>{{ project.description }} </span>
            </div>
            }
          </div>
          @if (getUsersWithAccess(project).length && !this.currentProject) {
          <frmg-user-logo-bundle
            [item]="project"
            (click)="share(project, $event)"
          >
          </frmg-user-logo-bundle>
          }
          <div class="list-element-actions">
            @if (editingProject?.id !== project.id) {
            <div class="list-element-actions-menu project">
              <inline-svg
                src="Hamburger_menu.svg"
                [ngClass]="{ hidden: !hasMenuActions(project) }"
                [matMenuTriggerFor]="actionMenu"
                #projectMenuTrigger="matMenuTrigger"
                [color]="projectMenuTrigger.menuOpen ? '#5E84F7' : '#A5B5BD'"
                hoverColor="#7F8F98"
                (click)="$event.stopPropagation()"
              ></inline-svg>
              <mat-menu #actionMenu="matMenu">
                @if (!project.is_archived && project.is_owned_by_current_user &&
                project.is_project) {
                <button
                  mat-menu-item
                  (click)="share(project)"
                  class="menu-slot"
                >
                  Share {{ project.is_project ? "" : "Folder" }}
                </button>
                } @if (project.is_project && project?.is_owned_by_current_user)
                {
                <button
                  mat-menu-item
                  (click)="archiveProject(project)"
                  class="menu-slot"
                >
                  {{ project.is_archived ? "Unarchive" : "Archive" }}
                </button>
                } @if (!project.is_archived && (project.is_project ?
                project.is_owned_by_current_user :
                project.effective_permissions.can_update)) {
                <button
                  mat-menu-item
                  (click)="editProject(project)"
                  class="menu-slot"
                >
                  Edit {{ project.is_project ? "" : "Folder" }}
                </button>
                } @if (!project.is_archived && !project.is_project &&
                (project.is_project ? project.is_owned_by_current_user :
                project.effective_permissions.can_update)) {
                <button
                  mat-menu-item
                  (click)="moveFolder(project)"
                  class="menu-slot"
                >
                  Move to
                </button>
                } @if (!project.is_archived && (project.is_project ?
                project.is_owned_by_current_user :
                project.effective_permissions.can_delete)) {
                <button
                  mat-menu-item
                  (click)="
                    deleteProject(project.id, $event, project.is_project)
                  "
                  class="menu-slot"
                >
                  Delete
                </button>
                } @if (!project.is_archived &&
                !project?.is_owned_by_current_user && project.is_project) {
                <button
                  mat-menu-item
                  (click)="unfollow(project.id)"
                  class="menu-slot"
                >
                  Remove from the List
                </button>
                }
              </mat-menu>
            </div>
            }
          </div>
        </div>
      </div>
      } } @if (currentProject?.path !== 'root' && !loadingData()) { @for (area
      of list; track area) {
      <div
        class="list-element area"
        [ngClass]="{ active: isSelected(area), highlighted: area.highlighted }"
        [id]="area.id"
        (click)="areaChecked(area, $event)"
        (mouseenter)="areaHovered(area)"
        (mouseleave)="areaHovered(null)"
      >
        <mat-checkbox
          [checked]="isSelected(area)"
          [disabled]="isCheckboxDisabled(area)"
          (change)="areaChecked(area, $event)"
          (click)="$event.stopPropagation()"
        >
        </mat-checkbox>
        <div class="list-element-container">
          <div class="list-element-info">
            <div class="list-element-size">
              <div [ngClass]="getAreaIconType(area)"></div>
              @if (area.geometry.type === 'LineString' || area.geometry.type === 'MultiLineString') {
              <span> {{ area.length_meters | m2km }} </span>
              } @else if (area.geometry.type !== 'Point') {
              <span> {{ area.area_sq_meters | m2km2 }} km<sup>2</sup> </span>
              }
            </div>
            <div class="list-element-title">
              <span>
                {{ area.name }}
              </span>
            </div>
            <div class="list-element-tags">
              <span>
                {{ createGroupString(area.properties.groups!) }}
              </span>
            </div>
          </div>
        </div>
        <div class="list-element-actions">
          <!--          @if (editingArea?.id !== area.id) {-->
          <div class="list-element-actions-menu">
            <!--            @if (area?.user?.email == currentUser.email) {-->
            <inline-svg
              src="Hamburger_menu.svg"
              [matMenuTriggerFor]="actionMenu"
              #areaMenuTrigger="matMenuTrigger"
              [color]="areaMenuTrigger.menuOpen ? '#5E84F7' : '#A5B5BD'"
              hoverColor="#7F8F98"
              (click)="$event.stopPropagation()"
            ></inline-svg>
            <!--            }-->
            <mat-menu #actionMenu="matMenu" class="action-menu">
              <button
                mat-menu-item
                (click)="editArea(area, $event)"
                class="menu-slot"
              >
                Edit Area
              </button>
              <button
                mat-menu-item
                (click)="moveArea(area, $event)"
                class="menu-slot"
              >
                Move to
              </button>
              <button
                mat-menu-item
                (click)="deleteArea(area)"
                class="menu-slot"
              >
                Delete Area
              </button>
            </mat-menu>
            <inline-svg
              src="focus.svg"
              (click)="focusOn(area, $event)"
              color="#A5B5BD"
              hoverColor="#7F8F98"
              matTooltip="Focus on area"
              class="focus-icon"
            ></inline-svg>
          </div>
          <!--          }-->
        </div>
      </div>
      } } @if (areasLoadingByScroll()) {
      <div class="list-element area">
        <div class="list-element-container">
          <div class="list-element-info">
            <div class="list-element-size"></div>
            <div class="list-element-title">
              <span> Loading... </span>
            </div>
            <div class="list-element-tags"></div>
          </div>
        </div>
      </div>
      } @if (!list?.length && !projects?.length && !loadingData()) {
      <div class="empty-list">
        <img src="assets/icons/info-chat.svg" alt="empty list" />
        <span class="empty-title"
          >No
          {{ currentProject?.path !== "root" ? "areas/folders" : "projects" }}
          found</span
        >
        @if (this.rootState == 'root' || (this.rootState === 'shared' &&
        currentProject?.path !== 'root') ) {
        <span
          >Please create new
          {{
            currentProject?.path !== "root"
              ? "area/folder or import one"
              : "project"
          }}</span
        >
        }
      </div>
      }
    </div>
  </div>
  <div class="horizontal-separator"></div>
  @if (currentProject && currentProject?.path !== 'root' && areaService.count) {
  <div class="areas-footer">
    <span>Showing {{ list?.length }} out of {{ areaService.count }}</span>
  </div>
  }
</div>

<ng-template #searchResult let-item="item">
  @if (item.path) {
  <inline-svg [src]="getProjectIconPath(item)" color="#85BBF3"></inline-svg>
  } @if (!item.path) {
  <inline-svg src="square.svg" color="#85BBF3"></inline-svg>
  }
  <div class="item-info">
    <div class="item-name">{{ item.name || item.properties?.name }}</div>
    <div class="item-path">
      @for (segment of transformSearchPath(item.path ||
      item.properties?.project?.path, item); track segment; let last = $last;
      let index = $index) { @if (segment.icon) {
      <inline-svg [src]="segment.icon" class="prefix segment-icon"></inline-svg>
      } @if (segment.label) {
      <span [class.final]="segment.final">{{ segment.label }}</span>
      } @if (!last) {
      <inline-svg src="arrow-middle.svg" class="arrow"></inline-svg>
      } }
    </div>
  </div>
</ng-template>
